<template>
<div>
    <div class="desktop">
        <b-list-group>
            <b-list-group-item :active="all" href="/languages/clubs">All Clubs</b-list-group-item>
            <b-list-group-item :active="create" href="/languages/clubs/create">Create Club </b-list-group-item>
            <b-list-group-item :active="created" href="/languages/clubs/created">Created Clubs </b-list-group-item>
            <b-list-group-item :active="requests" href="/languages/clubs/manage">Manage Requests</b-list-group-item>
            <b-list-group-item :active="bookings" href="/languages/clubs/bookings">My Bookings </b-list-group-item>

        </b-list-group>
    </div>
    <div class="mobile">
        <b-icon @click="handleOpen" icon="list" scale="2"></b-icon>
        <div class="slide-menu card sidecard" :id="menuId" v-click-outside="handleHide">
            <b-list-group>
                <b-list-group-item :active="all" href="/languages/clubs">All Clubs</b-list-group-item>
                <b-list-group-item :active="create" href="/languages/clubs/create">Create Club </b-list-group-item>
                <b-list-group-item :active="created" href="/languages/clubs/created">Created Clubs </b-list-group-item>
                <b-list-group-item :active="requests" href="/languages/clubs/manage">Manage Requests</b-list-group-item>
                <b-list-group-item :active="bookings" href="/languages/clubs/bookings">My Bookings </b-list-group-item>

            </b-list-group>
        </div>
    </div>
</div>
</template>

<script>
import vClickOutside from 'v-click-outside'
export default {
    name: 'language-clubs-sidebar',
    props: ['create', 'created', 'requests', 'bookings', 'menuId', 'all', 'options'],
    directives: {
        clickOutside: vClickOutside.directive
    },
    methods: {
        handleOpen() {
            this.$emit('handleOpen')
        },
        handleHide() {
            this.$emit('handleHide')
        },
    }
}
</script>

<style scoped>
.list-group {
    padding: 16px 16px 16px 16px;
    background: #FFFFFF;
    box-shadow: 2px 6px 19px rgba(0, 0, 0, 0.08);
    border-radius: 4px;
}

.list-group-item {
    padding: 0.7rem 1rem !important;
    text-align: left;
    border: none !important;
    margin: 10px 0 !important;
}

.list-group-item.active {
    background: rgba(86, 92, 99, 0.05) !important;
    color: rgba(86, 92, 99, 1) !important;
    text-align: center;
}

.sidecard {
    box-shadow: 2px 6px 19px rgb(0 0 0 / 3%);
    border-radius: 4px;
    padding: 16px !important;
    border: none !important;
}

.slide-menu {
    position: absolute;
    z-index: 999;
    background: #fff;
    margin-left: -360px;
    width: 328%;
    top: 0px;
    padding-left: 16px;
    transition: all 0.4s ease-in-out;
}
</style>
